import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';

import s from './WhyJopsy.module.scss';
import staticPageStyles from '../StaticPage.module.scss';
import getAssetLink from '../../../util/getAssetLink';
import { ROUTE_PREFIX } from '../../../constants/router';
// import { APP_STORE_LINK, PLAY_STORE_LINK } from '../../WebFooter';
import { withSEO } from '../../SEO/withSEO';

function WhyJopsy(): ReactElement {
  return (
    <div className={staticPageStyles.staticPage} data-nosnippet>
      <div className={staticPageStyles.card}>
        <div className={staticPageStyles.cardHeader}>
          <img src={getAssetLink('startpage/why_jopsy.png')} alt="" />
          <h1>WARUM JOPSY?</h1>
        </div>
        <div className={staticPageStyles.cardContent}>
          <h2 className={staticPageStyles.largerH2}>
            Warum solltest du Jopsy nutzen?
          </h2>
          <h2>
            Jopsy ist ein innovatives, bildbasiertes Berufsorientierungs-Tool,
            das dir hilft, deine Interessen herauszufinden und darauf basierend
            Vorschläge für passende Berufe macht.
          </h2>
          <p>
            Hier sind einige Gründe, warum du unbedingt Jopsy ausprobieren
            solltest:
          </p>
          <p>
            <h2>Schnelligkeit und Benutzer:innenfreundlichkeit</h2>
            Mit Jopsy brauchst du nur wenige Minuten, um mehr über deine
            Interessen zu erfahren und Vorschläge für Berufe zu bekommen, die zu
            dir passen könnten. Das Tool ist einfach zu bedienen und liefert dir
            schnell Ergebnisse, damit du dich direkt auf das Wesentliche
            konzentrieren kannst.
          </p>
          <p>
            <h2>Anonymität und Sicherheit</h2>
            Einer der großen Vorteile von Jopsy ist, dass du völlig anonym
            bleiben kannst. Du musst keine persönlichen Daten eingeben, wodurch
            du deine Interessen in einem sicheren Umfeld erforschen kannst. Du
            kannst ganz ehrlich sein, ohne Angst haben zu müssen, dass jemand
            mitliest.
          </p>
          <p>
            <h2>Wissenschaftliche Grundlage</h2>
            Jopsy basiert auf wissenschaftlichen Erkenntnissen und dem
            RIASEC-Modell von John Holland. Das heißt, die Berufsvorschläge, die
            du erhältst, sind fundiert und basieren auf bewährten Methoden. Du
            kannst also sicher sein, dass die Ergebnisse dir wirklich
            weiterhelfen.
          </p>
          <p>
            <h2>Laufende Aktualisierung</h2>
            Die Arbeitswelt verändert sich ständig und Jopsy hält Schritt. Das
            Tool wird regelmäßig aktualisiert, um dich über neue Berufe und
            Ausbildungen auf dem Laufenden zu halten.
            <br />
            <b>
              Nutze Jopsy, um schnell, sicher und wissenschaftlich fundiert
              deine Interessen zu entdecken und passende Berufe zu finden.
              Starte jetzt und lege den Grundstein für deine Zukunft!
            </b>
          </p>
          <p>
            <h2>Flexibilität und Verwendungsmöglichkeiten</h2>
            Die Jopsy-Ergebnisse kannst du für weitere Beratungsgespräche mit
            Bildungsberater:innen nutzen, zur Erstellung von
            Bewerbungsunterlagen oder für die persönliche Planung deiner
            Bildungs- und Berufslaufbahn.
          </p>
          <p>
            <h2>Kostenloser Zugang</h2>
            Jopsy ist kostenlos verfügbar, sowohl als App für iOS und Android
            als auch als Webversion. Dieses niedrigschwellige Angebot macht es
            einfach zugänglich für alle Personen, unabhängig von ihrem
            finanziellen Hintergrund.
          </p>
          {/* <p>Zugang zu Jopsy findest du hier:</p>
          <p>
            <Link to={`${ROUTE_PREFIX}/`}>www.jopsy.at</Link>
            <div className={s.storeLinks}>
              <a
                href={PLAY_STORE_LINK}
                target="_blank"
                rel="noreferrer"
                aria-label="Zum Play Store"
              >
                <img src={getAssetLink('playStore.png')} alt="Play Store" />
              </a>
              <a
                href={APP_STORE_LINK}
                target="_blank"
                rel="noreferrer"
                aria-label="Zum App Store"
              >
                <img src={getAssetLink('appStore.png')} alt="App Store" />
              </a>
            </div>
          </p> */}
          <p className={s.factsParagraph}>
            <Link
              className={`wideButton ${s.factsLink}`}
              to={`${ROUTE_PREFIX}/fakten`}
              aria-label='Zur "Facts" Unterseite'
            >
              <span>Weiter zu den Jopsy Facts</span>
              <img src={getAssetLink('startpage/learn_more.png')} alt="" />
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default withSEO({
  title: 'Jopsy | Warum Jopsy?',
  description:
    'Fragst du dich "Warum sollte ich Jopsy nutzen?". Dann schau doch mal hier vorbei und mach dich schlau.',
})(WhyJopsy);
